import { gql } from 'graphql-tag';
import type { TypedDocumentNode } from '@apollo/client';
import type { IGetSiteStatsData } from '../types';

export const GET_SITE_STATS: TypedDocumentNode<IGetSiteStatsData> = gql`
  query getSiteStats {
    viewer {
      id
      site {
        id
        stat {
          cta
          ctaTimestamp
          stat
          statTimestamp
        }
      }
    }
  }
`;
